export default [
  {
    path: '/behavior/index',
    name: 'PageBehaviorIndex',
    component: () =>
      import(
        /* webpackChunkName: "behavior" */ '../pages/behavior/gray/PageBehaviorIndex'
      ),
    meta: {
      modular: 151,
      keepAlive: true,
      title: '课堂行为',
      info: '课堂行为-首页'
    }
  },
  {
    path: '/behavior/stastic',
    name: 'PageBehaviorStastic',
    component: () =>
      import(
        /* webpackChunkName: "behavior" */ '../pages/behavior/gray/PageBehaviorStastic'
      ),
    meta: {
      modular: 151,
      keepAlive: true,
      title: '课堂行为',
      info: '课堂行为-统计'
    }
  },
  {
    path: '/behavior/detail',
    name: 'PageBehaviorDetail',
    component: () =>
      import(
        /* webpackChunkName: "behavior" */ '../pages/behavior/gray/PageBehaviorDetail'
      ),
    meta: { modular: 151, title: '详情', info: '课堂行为-详情' }
  },
  {
    path: '/behavior/export',
    name: 'PageBehaviorExport',
    component: () =>
      import(
        /* webpackChunkName: "behavior" */ '../pages/behavior/gray/PageBehaviorExport'
      ),
    meta: { modular: 151, title: '导出报表', info: '课堂行为-导出报表' }
  }
]
